<template>
    <div class="stms_container">
        <div class="index_container">
            <iframe
                id="d3-iframe"
                :class="['d3-iframe']"
                src="http://49.4.52.75:7090/smts-home"
                frameborder="0"
            ></iframe>
        </div>
    </div>
</template>
<script>
export default {
    name: "stms_home",
    components: {},
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
        
    },
    destroyed() {
    }
};
</script>
<style lang="scss">
.stms_container {
    width: 100%;
    height: 100%;
    position: relative;
    .index_container {
        width: 100%;
        height: 100%;
        position: absolute;
        .d3-iframe {
            width: 100%;
            height: 100%;
            margin-top: -1.6rem;
            position: absolute;
            left: 0;
            top: 0;
        }
    }
}
</style>
